import React from 'react';
import {curry} from 'ramda';
import {UserRolesEnum} from '@pluto/users';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CheckIcon from '@material-ui/icons/Check';
import classNames from 'classnames';

import {
    renderTextInputProps,
    UserOption,
    UsersProps,
} from './UsersTypes';

const renderTextInput = (props: renderTextInputProps) => {
    const {
        InputLabelProps,
        InputProps,
        disabled,
        fullWidth,
        inputProps,
        size,
    } = props;
    
    return (
        <TextField
            InputLabelProps={InputLabelProps}
            InputProps={InputProps}
            disabled={disabled}
            fullWidth={fullWidth}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            inputProps={inputProps}
            size={size}
            label="Filter by name or e-mail"
            variant="standard"
        />
    );
};

export const getOptionValue = (opt: UserOption) => opt.email;

export const renderOption = curry((assignedUser: any, opts: UserOption[], option: string) => {
    const isChecked = assignedUser?.email === option;
    const [optData] = opts.filter((opt) => opt.email === option);
    
    return (
        <div
            className={classNames('assign-option', {
                selected: isChecked,
            })}
        >
            <div className="assign-option__name">
                {optData?.name}  {optData?.email}
            </div>
            <div className="assign-option__is-checked">
                {isChecked && <CheckIcon className="assign-option__checked-icon" />}
            </div>
        </div>
    );
});

export const getFilteredUsers = (option: UserOption) => {
    return option.roles.includes(UserRolesEnum.QCOperator) && option.status === 'Active';
};

export default function Users(props: UsersProps) {
    const {
        getOptionSelected,
        getOptionLabel,
        opts,
        onChange,
        assignedUser,
    } = props;
    const filteredOptions = opts?.filter(getFilteredUsers);
    const options = filteredOptions?.map(getOptionValue);
    
    return (
        <Autocomplete
            id="users"
            open
            selectOnFocus
            options={options}
            renderOption={renderOption(assignedUser, filteredOptions) as any}
            getOptionLabel={getOptionLabel}
            getOptionSelected={getOptionSelected}
            renderInput={renderTextInput}
            onChange={onChange as any}
            value={assignedUser?.email || null}
        />
    );
}
